import React, {Component, PureComponent} from 'react';
import './styles.css';

/**
 *  Preloader
 */
class Preloader extends PureComponent {

  static IMAGE_WIDTH = 150;
  static IMAGE_HEIGHT = 150;
  static ROW_MAX = 6;
  static TOTAL_FRAMES = 40;

  constructor(props) {
    super();
    this.props = props;
    this.intervalId = null;
    this.currentFrame = 0;
    this.state = {
      top: 0,
      left: 0,
      loading: false,
    }
  }

  render() {
    return (
      <div className={'Preloader' + (this.props.loading ? ' visible' : '')}>
        <span>
          <span style={{backgroundPosition: this.state.left + 'px ' + this.state.top + 'px'}}/>
        </span>
      </div>
    )
  }

  componentWillReceiveProps(nextProps) {
    if (this.state.loading === nextProps.loading) return;
    this.setState({
      loading: nextProps.loading,
    });
    if (nextProps.loading === true) {
      this.stopAnimation();
      this.initAnimation();
      this.startAnimation();
    } else {
      this.stopAnimation();
    }
  }

  componentWillUnmount() {
    this.stopAnimation();
  }

  initAnimation = ()=> {
    this.currentFrame = 0;
    this.setState({
      top: 0,
      left: 0,
    });
  };

  startAnimation = ()=> {
    this.intervalId = setInterval(() => {
      this.setState({
        top: -Math.floor(this.currentFrame / Preloader.ROW_MAX) * Preloader.IMAGE_HEIGHT,
        left: -(this.currentFrame % Preloader.ROW_MAX) * Preloader.IMAGE_WIDTH,
      });
      //
      this.currentFrame = this.currentFrame + 1;
      if (Preloader.TOTAL_FRAMES <= this.currentFrame) {
        this.currentFrame = 0;
      }
    }, 1000 / 40)
  };

  stopAnimation = ()=> {
    if (this.intervalId) clearInterval(this.intervalId);
  }

}

export default Preloader;



// WEBPACK FOOTER //
// ./src/components/preloader/index.jsx